import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.dsiacdata.solutions/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    // Se token expirou ou é inválido, limpar localStorage
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      
      // Redirecionar para login se não estiver na página de login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export const noticiasAPI = {
  getAll: (produto) => api.get(`/noticias${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/noticias/${id}`),
  create: (data) => api.post('/noticias', data),
  update: (id, data) => api.put(`/noticias/${id}`, data),
  delete: (id) => api.delete(`/noticias/${id}`),
};

export const perguntasAPI = {
  getAll: (produto) => api.get(`/perguntas${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/perguntas/${id}`),
  create: (data) => api.post('/perguntas', data),
  update: (id, data) => api.put(`/perguntas/${id}`, data),
  delete: (id) => api.delete(`/perguntas/${id}`),
};

export const publicacoesAPI = {
  getAll: (produto) => api.get(`/publicacoes${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/publicacoes/${id}`),
  create: (data) => api.post('/publicacoes', data),
  update: (id, data) => api.put(`/publicacoes/${id}`, data),
  delete: (id) => api.delete(`/publicacoes/${id}`),
};

export const parceirosAPI = {
  getAll: (produto) => api.get(`/parceiros${produto ? `?produto=${produto}` : ''}`),
  getById: (id) => api.get(`/parceiros/${id}`),
  create: (data) => api.post('/parceiros', data),
  update: (id, data) => api.put(`/parceiros/${id}`, data),
  delete: (id) => api.delete(`/parceiros/${id}`),
};

export const uploadAPI = {
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(res => res.data); // retorna apenas os dados da resposta
  },
  deleteFile: (filename) => api.delete(`/upload/${filename}`),
};

export default api;
